import { render } from "./thProcess.vue?vue&type=template&id=7ced963e&scoped=true"
import script from "./thProcess.vue?vue&type=script&lang=js"
export * from "./thProcess.vue?vue&type=script&lang=js"

import "./thProcess.vue?vue&type=style&index=0&id=7ced963e&scoped=true&lang=scss"

import exportComponent from "D:\\sycode\\ijj-web\\iseso-mall-pc-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ced963e"]])

export default __exports__